export function getPaymentInfo(booking, paymentStatus) {
  const payment = paymentStatus || booking?.payment || {};
  const status = payment?.status || booking?.paymentStatus;
  return {
    status,
    method: payment?.method || booking?.paymentMethod,
    driverConfirmedAt:
      payment?.driverConfirmedAt ?? booking?.payment?.driverConfirmedAt ?? null,
  };
}

export function isUserPaymentSubmitted(booking, paymentStatus) {
  return getPaymentInfo(booking, paymentStatus).status === 'completed';
}

export function isDriverPaymentConfirmed(booking, paymentStatus) {
  if (!isUserPaymentSubmitted(booking, paymentStatus)) {
    return false;
  }
  return Boolean(getPaymentInfo(booking, paymentStatus).driverConfirmedAt);
}

export function isPaymentFullySettled(booking, paymentStatus) {
  return isDriverPaymentConfirmed(booking, paymentStatus);
}
